export default __webpack_public_path__ + "static/media/features-section-4.0808e9e3.png";